import styled from 'styled-components';
import { View } from '../View/view';

export const Row = styled(View)`
    display: flex;
    align-items: center;
`;


